/**
 * Created by Tiger on 08/03/2022.
 */
import React from 'react';
import {Modal, Result} from 'antd';
import s from './result-modal.module.scss'

export const resultModal = (props) => {
  Modal.info({
    icon: null,
    // okText: <></>,
    content: <>
      <Result style={{marginTop:-40, marginBottom:-80}} { ...props }/>
    </>,
  });
};

